module.exports = __webpack_public_path__ + "static/media/BRC.aab863f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/BRC.png
// module id = 383
// module chunks = 0